<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../cn'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="cn('lucide lucide-plus-icon lucide-plus size-4', props.class)"
  >
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </svg>
</template>
